import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { useAppSelector } from "src/store";
import { getDataTypes, getSectors } from "src/store/system/saga";
import { DataTypeDto, SectorDto } from "src/store/system/type";
import { createAssetFeatureSaga } from "src/store/asset-features/saga";
import * as Yup from "yup";
import { AssetTypeDto } from "src/store/asset-types/type";
import { getAssetTypeListSaga } from "src/store/asset-types/saga";

const AssetFeatureCreateForm = ({
  onHide,
  open,
  onSuccessClick,
}: {
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const languages = useAppSelector((s) => s.language.languages);
  const [assettypes, setAssettypes] = useState<AssetTypeDto[]>([]);
  const [datatypes, setDatatypes] = useState<DataTypeDto[]>([]);
  useEffect(() => {
    if (open) {
      dispatch(
        getDataTypes({
          payload: {
            onSuccess: (message, payload) => {
              setDatatypes(payload);
            },
            onError: () => {},
          },
        })
      );
      dispatch(
        getAssetTypeListSaga({
          payload: {
            onSuccess: (message, payload) => {
              setAssettypes(payload);
            },
            onError: () => {},
          },
        })
      );
    }
  }, [dispatch, open]);
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("AssetFeature.CreateFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Name: "",
          AssetTypeId: "",
          DataTypeId: "",
          Translates: languages.map((x) => {
            return { LanguageId: x.EnumId, Name: "" };
          }),
        }}
        onSubmit={(values) => {
          dispatch(
            createAssetFeatureSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          Name: Yup.string().required(t("Validation.Required").toString()),
          AssetTypeId: Yup.string().required(
            t("Validation.Required").toString()
          ),
          DataTypeId: Yup.number().required(
            t("Validation.Required").toString()
          ),
        })}
        multilanguageinputs={[
          {
            field: "Name",
            label: t("AssetFeature.Name").toString(),
          },
        ]}
        inputs={[
          {
            field: "AssetTypeId",
            label: t("AssetFeature.AssetType").toString(),
            type: "select",
            lookup: {
              labelKey: "Name",
              valueKey: "Id",
              options: assettypes,
            },
          },
          {
            field: "DataTypeId",
            label: t("AssetFeature.DataType").toString(),
            type: "select",
            lookup: {
              labelKey: "Name",
              valueKey: "EnumId",
              options: datatypes,
            },
          },
        ]}
      />
    </React.Fragment>
  );
};
export default AssetFeatureCreateForm;
